// extracted by mini-css-extract-plugin
var _1 = "CardActionsPopup_icon__y4uWj";
export { _1 as "icon" }
